import { FC } from 'react';
import { Project, Competition, Book } from "@brg/api";
import {ProjectInExamBlock} from "../styles";
import { useTranslation } from 'react-i18next';
import {Colors, FlexBox} from '@brg/ui';
import { ArrowCornerSvg } from 'shared/assets/16/ArrowCornerSvg';
import {
    getCompetitionExamResults,
    getCompetitionTitle
} from '_competition/pages/AllCompetitionsPage/helpers/competitionUtils';

export const InPartExam: FC<{ project: Project | Book, competitionsExamCompleted: Competition[], lmsModuleApprove?: boolean }> = ({ project, competitionsExamCompleted, lmsModuleApprove }) => {
    const { t } = useTranslation();
    if (competitionsExamCompleted.length === 0 || !lmsModuleApprove) {
        return null;
    }

    return (
        <>{competitionsExamCompleted?.map((exam: Competition) => {
        return <ProjectInExamBlock>
            <FlexBox width='100%' justify='space-between'>
                <FlexBox direction="column" directionMobile="column" >
                    <FlexBox className='competition-exam-label'>{t('project_edit.lms.take_part')}</FlexBox>
                    <FlexBox className='competition-exam-title'>{getCompetitionTitle(exam)}</FlexBox>
                    <FlexBox className='competition-exam-label' offsetTop={24}>{t('project_edit.lms.marks')}</FlexBox>
                    <FlexBox className='competition-exam-grade-result' offsetTop={8} gx={8}>
                        <div>{t('project_edit.lms.final')}</div>
                        <div>{getCompetitionExamResults(project, exam)}</div>
                    </FlexBox>
                </FlexBox>
                <FlexBox offsetBottom={4}>
                    {/*@ts-ignore*/}
                    <a href={exam?.link || `/project/${exam?.lmsModuleProjectId}`} target={'_BLANK'} rel="noreferrer">
                        {t('project_edit.lms.link_to_course')}&nbsp;<ArrowCornerSvg clr={Colors.galBlack47} opacity={'1'} />
                    </a>
                </FlexBox>
            </FlexBox>
        </ProjectInExamBlock>})}</>
    )
}import { FC } from 'react';
import { Project, Competition, Book } from "@brg/api";
import {ProjectInExamBlock} from "../styles";
import { useTranslation } from 'react-i18next';
import {Colors, FlexBox} from '@brg/ui';
import { ArrowCornerSvg } from 'shared/assets/16/ArrowCornerSvg';
import {
    getCompetitionExamResults,
    getCompetitionTitle
} from '_competition/pages/AllCompetitionsPage/helpers/competitionUtils';

export const InPartExam: FC<{ project: Project | Book, competitionsExamCompleted: Competition[], lmsModuleApprove?: boolean }> = ({ project, competitionsExamCompleted, lmsModuleApprove }) => {
    const { t } = useTranslation();
    if (competitionsExamCompleted.length === 0 || !lmsModuleApprove) {
        return null;
    }

    return (
        <>{competitionsExamCompleted?.map((exam: Competition) => {
        return <ProjectInExamBlock>
            <FlexBox width='100%' justify='space-between'>
                <FlexBox direction="column" directionMobile="column" >
                    <FlexBox className='competition-exam-label'>{t('project_edit.lms.take_part')}</FlexBox>
                    <FlexBox className='competition-exam-title'>{getCompetitionTitle(exam)}</FlexBox>
                    <FlexBox className='competition-exam-label' offsetTop={24}>{t('project_edit.lms.marks')}</FlexBox>
                    <FlexBox className='competition-exam-grade-result' offsetTop={8} gx={8}>
                        <div>{t('project_edit.lms.final')}</div>
                        <div>{getCompetitionExamResults(project, exam)}</div>
                    </FlexBox>
                </FlexBox>
                <FlexBox offsetBottom={4}>
                    {/*@ts-ignore*/}
                    <a href={exam?.link || `/project/${exam?.lmsModuleProjectId}`} target={'_BLANK'} rel="noreferrer">
                        {t('project_edit.lms.link_to_course')}&nbsp;<ArrowCornerSvg clr={Colors.galBlack47} opacity={'1'} />
                    </a>
                </FlexBox>
            </FlexBox>
        </ProjectInExamBlock>})}</>
    )
}